import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 bg-cream" data-id="element-253">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <div className="flex flex-col md:flex-row gap-12 items-start" data-id="element-255">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/3 hidden md:block sticky top-24" data-id="element-256">
            <div className="bg-terracotta/10 rounded-2xl p-8 border border-terracotta/20" data-id="element-257">
              <AlertCircle className="h-12 w-12 text-terracotta mb-4" data-id="element-258" />
              <h3 className="text-xl font-bold text-forest mb-2" data-id="element-259">
                La Parálisis por Análisis
              </h3>
              <p className="text-forest/70 text-sm" data-id="element-260">
                Tener demasiada información contradictoria es tan peligroso como
                no tener ninguna.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-2/3 space-y-6 text-lg text-forest/80" data-id="element-261">
            <h2 className="text-3xl md:text-4xl font-bold text-forest mb-6" data-id="element-262">
              El problema no es que no te importa tu hijo.
            </h2>

            <p data-id="element-263">
              El problema es que{' '}
              <span className="font-bold text-forest" data-id="element-264">
                nadie te dio un protocolo claro.
              </span>
            </p>

            <p data-id="element-265">
              ✅ Qué hacer en los primeros 60 segundos ✅ Cuándo actuar en casa
              y cuándo ir al médico ✅ Con ingredientes que ya tienes en casa
            </p>

            <p data-id="element-266"></p>

            <p className="font-medium text-forest" data-id="element-267">
              La parálisis que sientes en esos momentos no es debilidad.
            </p>

            <p data-id="element-268">
              Es el resultado natural de tener demasiada información y cero
              sistema.
            </p>

            <div className="mt-8 p-6 bg-white rounded-xl shadow-sm border-l-4 border-terracotta" data-id="element-269">
              <p className="text-xl font-bold text-terracotta font-serif" data-id="element-270">
                ¿Cuántas veces más vas a buscar en Google a medianoche sin
                encontrar una respuesta clara?
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}